require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es6.typed.float64-array.js
// module id = 261
// module chunks = 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21